export const SET_CART_OFFERS = 'SET_CART_OFFERS';
export const CHECK_ALL_CART_OFFERS = 'CHECK_ALL_CART_OFFERS';
export const DELETE_CART_OFFERS = 'DELETE_CART_OFFERS';
export const CHECK_CART_OFFER = 'CHECK_CART_OFFER';

export const SET_CART_COUPON = 'SET_CART_COUPON';
export const REMOVE_CART_COUPON = 'REMOVE_CART_COUPON';
